module.exports = __webpack_public_path__ + "static/rapidfresh-banner-02c703373814d9d4e3005690c24ec6b1.png";